import React from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const PickupListSearchBar = ({ searchText, onSearch }) => {
  return (
    <Input
      placeholder="Search by list number, student name, SPC, or BOTPC..."
      prefix={<SearchOutlined />}
      value={searchText}
      onChange={(e) => onSearch(e.target.value)}
      allowClear
      size="large"
      style={{ width: "100%" }}
    />
  );
};

export default PickupListSearchBar;
